export const loginConstraints = {
    email: { validEmail: true },
    password: { presence: { allowEmpty: false } },
};
